import { IconButton, Tooltip } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import Icon from 'components/Icon'

export const CopyClipboardButton: React.FC<{
  content: string
  tooltipText: string
}> = ({ content, tooltipText, ...rest }) => {
  const [isCopied, setIsCopied] = useState(false)
  const timeoutRef = useRef(null)
  useEffect(() => {
    if (isCopied) {
      timeoutRef.current = setTimeout(() => setIsCopied(false), 3_000)
    }
    return () => clearTimeout(timeoutRef.current)
  }, [isCopied, timeoutRef])
  return (
    <div {...rest}>
      <Tooltip title={isCopied ? 'Copied' : tooltipText}>
        <div>
          <CopyToClipboard text={content} onCopy={() => setIsCopied(true)}>
            <IconButton
              aria-label="copy-to-clipboard"
              color="inherit"
              css={{
                padding: 0,
                verticalAlign: 'text-top'
              }}
              size="small"
            >
              <Icon icon="copy" />
            </IconButton>
          </CopyToClipboard>
        </div>
      </Tooltip>
    </div>
  )
}
